import { render, staticRenderFns } from "./PlainCard.vue?vue&type=template&id=1dfa5c9c&"
import script from "./PlainCard.vue?vue&type=script&lang=js&"
export * from "./PlainCard.vue?vue&type=script&lang=js&"
import style0 from "./PlainCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports